import { Injectable } from '@angular/core';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { of } from 'rxjs';
import { map, catchError, concatMap } from 'rxjs/operators';
import * as studentsActions from '../action/students-statistics.actions';
import { AdministratorStatisticsService } from '../../../../../../services/administrator-statistics.service';

@Injectable()
export class StudentsStatisticsEffects {
   constructor(
      private actions$: Actions,
      private administratorStatistics: AdministratorStatisticsService
   ) {}

   /**
    * Effect listening for StudentsStatistics Action, when StudentsStatistics is dispatched the effect with call create() from courseService.
    * In case of success response the effect it will trigger StudentsStatisticsSuccess.
    * In case of Error it will trigger StudentsStatisticsFailure with error property.
    */
   StudentsStatistics$ = createEffect(() => {
      return this.actions$.pipe(
         ofType(studentsActions.loadStudentsStatistics),
         concatMap((action) => {
            return this.administratorStatistics
               .studentsStatistics(
                  action.page,
                  action.facultyId,
                  action.departmentId,
                  action.studentName,
                  action.subject
               )
               .pipe(
                  map((data) => {
                     return studentsActions.loadStudentsStatisticsSuccess({
                        data: data,
                     });
                  }),
                  catchError((error) =>
                     of(
                        studentsActions.loadStudentsStatisticsFailure({
                           error,
                        })
                     )
                  )
               );
         })
      );
   });
}
